import { render, staticRenderFns } from "./LongTermLearning.vue?vue&type=template&id=562ea65b&scoped=true&"
import script from "./LongTermLearning.vue?vue&type=script&lang=js&"
export * from "./LongTermLearning.vue?vue&type=script&lang=js&"
import style0 from "./LongTermLearning.vue?vue&type=style&index=0&id=562ea65b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ea65b",
  null
  
)

export default component.exports